export default __webpack_public_path__ + "static/media/baseball-icon.b5916e72.svg";